import { indexOf, isUndefined, join, split } from 'lodash';
import moment from 'moment';

function getUrlQueryParameter(parameterName) {
  var result = [];
  var search = window.location.search.substring(1);
  var searchParameters = search.split('&');
  for (var i = 0; i < searchParameters.length; i++) {
    var parameter = searchParameters[i].split('=');
    if (parameter[0] === parameterName && indexOf(result, parameter[1]) === -1) {
      if (isUndefined(parameter[1])) {
        parameter[1] = true;
      }
      if (parameter[1] === 'true') {
        parameter[1] = true;
      }
      if (parameter[1] === 'false') {
        parameter[1] = false;
      }
      result.push(parameter[1]);
    }
  }
  return result;
}

function parseExternalId(externalId) {
  const tmpArray = split(externalId, '-');
  tmpArray.shift();
  return join(tmpArray, '');
}

function getDatesArray(startDate, stopDate) {
  let dateArray = [];
  let currentDate = moment(startDate);
  stopDate = moment(stopDate);
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).toDate());
    currentDate = moment(currentDate).add(1, 'days');
  }
  return dateArray;
}

function isInArray(array, value) {
  return !!array.find(item => {
    return moment(item).format('YYYY-MM-DD') === moment(value).format('YYYY-MM-DD')
  });
}

export default {
  getUrlQueryParameter,
  parseExternalId,
  getDatesArray,
  isInArray
}
